import apiClient from './api';
import type {
  ShippingSender,
  CreateShippingSenderRequest,
  UpdateShippingSenderRequest,
  ShippingApiKeyResponse,
} from '../types/shippingSender';

export const shippingSenderService = {
  listSenders: async (companyId: number): Promise<ShippingSender[]> => {
    const response = await apiClient.get<ShippingSender[]>(`/v1/companies/${companyId}/shipping-senders`);
    return response.data;
  },

  createSender: async (companyId: number, request: CreateShippingSenderRequest): Promise<ShippingSender> => {
    const response = await apiClient.post<ShippingSender>(`/v1/companies/${companyId}/shipping-senders`, request);
    return response.data;
  },

  updateSender: async (
    companyId: number,
    senderId: number,
    request: UpdateShippingSenderRequest,
  ): Promise<ShippingSender> => {
    const response = await apiClient.put<ShippingSender>(
      `/v1/companies/${companyId}/shipping-senders/${senderId}`,
      request,
    );
    return response.data;
  },

  deactivateSender: async (companyId: number, senderId: number): Promise<void> => {
    await apiClient.delete(`/v1/companies/${companyId}/shipping-senders/${senderId}`);
  },

  getApiKeyForFrontend: async (companyId: number, senderId: number): Promise<string> => {
    const response = await apiClient.get<ShippingApiKeyResponse>(
      `/v1/companies/${companyId}/shipping-senders/${senderId}/api-key`,
    );
    return response.data.apiKey;
  },
};
